import store from '@/store';
import { sendLog } from '@/utils/sentry';
import { get as idbGet, set as idbSet, del as idbDel, entries as idbEntries, delMany as idbDelMany } from 'idb-keyval';
import { parseJSON } from '@/utils';
import { sortBy } from 'lodash-es';

const dataKey = 'XJ_IMAGE_EDITOR_DATA';
const idsKey = 'XJ_IMAGE_EDITOR_IDS';
const layerSortTipKey = 'XJ_SHOW_LAYER_SORT_TIP';
const maxLength = 100;

export const getEditorDataByRequestIdLocal = requestId => {
  return idbGet(requestId).then(res => {
    return parseJSON(res, {});
  });
};

export const getEditorDataByRequestIdRemote = requestId => {
  return new Promise(async resolve => {
    try {
      const res = await store.dispatch('user/getCache', { requestId });
      res ? resolve(res) : getEditorDataByRequestIdLocal(requestId).then(resolve);
    } catch (res) {
      getEditorDataByRequestIdLocal(requestId).then(resolve);
    }
  });
};

export const deleteCacheByRequestId = requestId => {
  localStorage.removeItem(dataKey);
  localStorage.removeItem(idsKey);
  return idbDel(requestId);
};

export const saveDraft = () => {
  return new Promise(resolve => {
    try {
      // 开发环境不保存草稿
      // if (import.meta.env.DEV) return false;
      const { requestId } = store.state.multi;
      const { userInfo } = store.state.user;
      const { history, currentIndex } = store.state.record;
      const { manualSortedUids } = store.state.app;
      if (currentIndex > 0) {
        try {
          const draftData = history[currentIndex];

          if (draftData.requestId !== requestId) return;

          const currentRequestIdInfo = JSON.stringify({ ...draftData, manualSortedUids, timestamp: +new Date() });
          // 登录用户
          if (userInfo?.id) {
            store
              .dispatch('user/setCache', {
                requestId,
                v: currentRequestIdInfo,
              })
              .then(resolve)
              .catch(resolve);
          }
          // erp等未登录用户，操作历史记录在indexeddb中
          else {
            idbEntries().then(res => {
              console.log('idbEntries', res);
              const len = res.length;
              if (len > maxLength) {
                try {
                  // 按时间排序后删除老的
                  const resParsed = res.map(i => ({ requestId: i[0], timestamp: JSON.parse(i[1])?.timestamp }));
                  const sorted = sortBy(resParsed, i => i.timestamp);
                  console.log('idbEntries sorted', sorted);
                  idbDelMany(sorted.slice(0, len - maxLength).map(i => i.requestId)).then(() => {
                    idbSet(requestId, currentRequestIdInfo).then(resolve);
                  });
                } catch (err) {
                  resolve();
                }
              } else {
                idbSet(requestId, currentRequestIdInfo).then(resolve);
              }
            });
          }
        } catch (err) {
          sendLog(`saveDraft_error222: ${err.message}`);
          resolve();
        }
        return true;
      } else {
        resolve();
      }
      return false;
    } catch (err) {
      sendLog(`saveDraft_error: ${err.message}`);
      resolve();
    }
  });
};

if (import.meta.env.DEV) {
  window.$saveDraft = saveDraft;
}

export const getLayerSortTip = () => {
  return localStorage.getItem(layerSortTipKey) !== '0';
};

export const hideLayerSortTip = () => {
  return localStorage.setItem(layerSortTipKey, '0');
};

export const getTargetLangManualFont = lang => {
  const map = JSON.parse(localStorage.getItem('lang-font-map'));
  return map ? map[lang] : '';
};

export const setTargetLangManualFont = (lang, font) => {
  let map = JSON.parse(localStorage.getItem('lang-font-map'));
  if (!map) {
    map = {};
  } else {
  }
  map[lang] = font;
  localStorage.setItem('lang-font-map', JSON.stringify(map));
};

export const setTranslateEngine = v => {
  localStorage.setItem('XJ_IMAGE_EDITOR_TRANS_ENGINE', '' + v);
};

export const getTranslateEngine = () => {
  return +localStorage.getItem('XJ_IMAGE_EDITOR_TRANS_ENGINE') || 0;
};
